import { CheckValue } from 'elements/minute/sidebar/sidebarComponents/atomic/CheckValue';
import { SliderValue } from 'elements/minute/sidebar/sidebarComponents/atomic/SliderValue';
import { ColorPalette } from 'elements/minute/sidebar/sidebarComponents/complex/ColorPalette';
import { SidebarContent } from 'elements/minute/sidebar/sidebarSection/SidebarContent';
import { SidebarSection } from 'elements/minute/sidebar/sidebarSection/SidebarSection';
import { SidebarSubsection } from 'elements/minute/sidebar/sidebarSection/SidebarSubsection';
import { useMapheimDebounced } from 'hooks/general/useMapheimDebounced';
import { useContext } from 'react';
import { ILineV2World, ILineV2WorldMarker } from 'react-give-me-map';
import { CtxEdit } from 'session/ctxEdit';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    marker: ILineV2WorldMarker;
}

const LINE_WIDTH_STEPS = [1, 2, 3, 4, 5];
const DASH_DEFAULT_VALUES: ILineV2World['dashed'] = {
    isDashed: true,
    lineLength: 5,
    gapLength: 3
};

export const LineMarkerStyleSection = (props: Props): JSX.Element => {
    const ctxEdit = useContext(CtxEdit);

    const { marker } = props;

    function updateWidth(value: number) {
        ctxEdit.updateWorldMarkerData(marker.id, { width: value });
    }

    const updateWidthDebounced = useMapheimDebounced(updateWidth, 100);

    function updateColor(value: string) {
        ctxEdit.updateWorldMarkerData(marker.id, { color: value });
    }

    function setIsDashed(value: boolean) {
        const dashed = value ? DASH_DEFAULT_VALUES : null;
        ctxEdit.updateWorldMarkerData(marker.id, { dashed });
    }

    return (
        <S_LineMarkerStyleSection className={props.className}>
            <SidebarSection title={Localization.STYLE} icon={{ iconName: 'brush' }}>
                <SidebarSubsection title={Localization.COLOR} icon={{ iconName: 'circle' }}>
                    <SidebarContent>
                        <ColorPalette
                            value={marker.elementData.color}
                            pickerAllowed
                            onChange={updateColor}
                        />
                    </SidebarContent>
                </SidebarSubsection>
                <SidebarSubsection title={Localization.SIZE} icon={{ iconName: 'ruler' }}>
                    <SidebarContent>
                        <SliderValue
                            steps={LINE_WIDTH_STEPS}
                            value={marker.elementData.width}
                            onValueChange={updateWidthDebounced}
                        />
                    </SidebarContent>
                </SidebarSubsection>
                <SidebarSubsection
                    title={Localization.DASHED}
                    icon={{ iconName: 'square-dashed' }}
                    disableBottomBorder
                >
                    <SidebarContent>
                        <CheckValue
                            label={
                                marker.elementData.dashed?.isDashed
                                    ? Localization.YES
                                    : Localization.NO
                            }
                            value={marker.elementData.dashed?.isDashed}
                            onChange={setIsDashed}
                        />
                    </SidebarContent>
                </SidebarSubsection>
            </SidebarSection>
        </S_LineMarkerStyleSection>
    );
};

const S_LineMarkerStyleSection = styled.div``;
